"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var queueTime_styles_1 = require("./queueTime.styles");
var core_components_1 = require("@securityproducts/core-components");
var queueTime_i18n_1 = require("./queueTime.i18n");
function QueueTime(props) {
    var strings = core_components_1.useLocalisation(queueTime_i18n_1.queueTimeTranslations, props.language);
    var infoText = React.createElement("div", { className: queueTime_styles_1.tooltip }, strings.infoText);
    var average = {
        name: strings.average,
        data: props.average,
        type: "line",
    };
    var maximum = {
        name: strings.maximum,
        data: props.maximum,
        type: "line",
    };
    var max = getMax(props.maximum, props.sla);
    var ranges = getSlaRanges(props.sla, max);
    var annotations = getAnnotationsFromRanges(ranges, max);
    return (React.createElement("div", { className: queueTime_styles_1.chartWrapper },
        React.createElement(core_components_1.LineChart, { id: "queue-time-chart", heading: strings.queueTime, info: infoText, metric: "time", displayRange: props.display, lineStyles: [
                { stroke: "#0085c7", fill: "#0085c7" },
                { stroke: "#acdef8", fill: "#acdef8" },
            ], data: [average, maximum], annotations: annotations, max: max, language: props.language, timezone: props.timezone })));
}
exports.QueueTime = QueueTime;
QueueTime.defaultProps = {
    average: [],
    maximum: [],
};
function getMax(points, sla) {
    if (points && points.length > 0) {
        var copy = JSON.parse(JSON.stringify(points));
        var max = copy.sort(function (a, b) { return b.value - a.value; })[0].value;
        if (max === 0) {
            return 0;
        }
        else if (max < sla) {
            return sla;
        }
        else if (max > sla && max < sla * 2) {
            return sla * 2;
        }
        else {
            return max;
        }
    }
    return 0;
}
function getSlaRanges(sla, max) {
    var ranges = [];
    if (max > 0) {
        ranges.push({ value: sla, fill: "#eef5e4" });
    }
    if (max > sla) {
        ranges.push({ value: sla * 2, fill: "#fffae2" });
    }
    if (max > sla * 2) {
        ranges.push({ value: max, fill: "#fbf3f3" });
    }
    return ranges;
}
function getAnnotationsFromRanges(ranges, max) {
    return ranges.map(function (range, index) { return ({
        axis: "y",
        start: index === 0 ? 0 : ranges[index - 1].value,
        end: index === 2 ? max : range.value,
        fill: range.fill,
    }); });
}
